/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgShield(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M11.737 1.298a.75.75 0 01.526 0l8 3A.75.75 0 0120.75 5v7c0 2.253-1.012 4.209-2.278 5.777-1.267 1.57-2.832 2.804-4.05 3.634a.778.778 0 01-.034.022l-2 1.209a.75.75 0 01-.772.002l-1.783-1.062a.777.777 0 01-.03-.02c-1.212-.805-2.831-2.044-4.156-3.64C4.325 16.33 3.25 14.323 3.25 12V5a.75.75 0 01.487-.702l8-3zM4.75 5.52V12c0 1.845.855 3.523 2.052 4.965 1.19 1.433 2.67 2.576 3.815 3.338l1.38.822 1.597-.965c1.15-.785 2.576-1.92 3.711-3.326C18.446 15.421 19.25 13.79 19.25 12V5.52L12 2.8 4.75 5.52z'
      />
    </svg>
  );
}

export default SvgShield;
